import type {
    PowerOfAttorneyApplyModel,
    PowerOfAttorneyModel,
    PowerOfAttorneyRemoveModel,
    UserProfileModel,
} from "api";
import { alertRequest, body, request } from "services/request";

const resource = "api/userProfile";

const showUser = (): Promise<UserProfileModel> => request(`${resource}/get`, { method: "GET" });
const getPowerOfAttorneys = (params?: { legalPersonId?: number | null }): Promise<PowerOfAttorneyModel[]> => {
    const query = params?.legalPersonId != null ? `?legalPersonId=${params.legalPersonId}` : "";
    return request(`${resource}/getPowerOfAttorneys${query}`, { method: "GET" });
};
const applyPowerOfAttorney = (params: PowerOfAttorneyApplyModel) =>
    alertRequest(`${resource}/applyPowerOfAttorney`, body(params));
const removePowerOfAttorney = (params: PowerOfAttorneyRemoveModel) =>
    alertRequest(`${resource}/removePowerOfAttorney`, body(params));
const showNotificationOptions = () => request(`${resource}/getNotificationOptions`, { method: "GET" });
const editNotificationOptions = (params: {}) => alertRequest(`${resource}/editNotificationOptions`, body(params));
const updatePassword = (params: {}) => alertRequest(`${resource}/editPassword`, body(params));
const updateUserAvatar = (params: {}) => alertRequest(`${resource}/editAvatar`, params);
const updateInformation = (params: {}) => alertRequest(`${resource}/edit`, body(params));
const updatePhoneSendCode = (params: {}) => alertRequest(`${resource}/editPhoneSendCode`, body(params));
const updatePhone = (params: {}) => alertRequest(`${resource}/editPhone`, body(params));
const delUserAvatar = (params: {}) => alertRequest(`${resource}/clearAvatar`, body(params));
const delAccount = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const setWebToken = (params: {}) => request(`${resource}/setWebToken`, body(params));
const startTfaSetupAuthenticator = () => request(`${resource}/startTfaSetupAuthenticator`, body({}));
const startTfaSetup = (params: {}) => request(`${resource}/startTfaSetup`, body(params));
const finishTfaSetup = (params: {}) => alertRequest(`${resource}/finishTfaSetup`, body(params));
const startTfaDisabling = () => request(`${resource}/startTfaDisabling`, {});
const finishTfaDisabling = (params: {}) => request(`${resource}/finishTfaDisabling`, body(params));
const getOrderNotificationOption = () => request(`${resource}/getOrderNotificationOption`, { method: "GET" });
const setOrderNotificationOption = (params: {}) => alertRequest(`${resource}/setOrderNotificationOption`, body(params));
const getOnboarding = () => request(`api/user/getOnboarding`, { method: "GET" });
const applyOnboarding = (params: {}) => request(`api/user/applyOnboarding`, body(params));

export {
    showUser,
    getPowerOfAttorneys,
    applyPowerOfAttorney,
    removePowerOfAttorney,
    updateInformation,
    updateUserAvatar,
    updatePhoneSendCode,
    updatePhone,
    updatePassword,
    delUserAvatar,
    delAccount,
    showNotificationOptions,
    editNotificationOptions,
    setWebToken,
    startTfaSetupAuthenticator,
    startTfaSetup,
    finishTfaSetup,
    startTfaDisabling,
    finishTfaDisabling,
    getOrderNotificationOption,
    setOrderNotificationOption,
    getOnboarding,
    applyOnboarding,
};
